import React, { forwardRef } from "react";
import { Plan2PlateIconButton } from "./Plan2PlateIconButton";

export const FastIntakeButton = forwardRef<
  HTMLButtonElement,
  { onClick: () => void }
>((props, ref) => {
    return (
      <Plan2PlateIconButton
        ref={ref}
        data-cy="fast-intake-button"
        aria-label={"fastIntake"}
        title={"Schnell Verzehren"}
        icon={"fastIntake"}
        onClick={props.onClick}
      />
    );
  },
);
